var map = {
	"./add_photo.svg": 58650,
	"./alert-circle.svg": 36777,
	"./alert-triangle.svg": 30285,
	"./alert_high.svg": 69667,
	"./alert_low.svg": 73839,
	"./alert_med.svg": 90471,
	"./arrow-back.svg": 25059,
	"./arrow-right-long-solid.svg": 38625,
	"./arrow_down.svg": 81648,
	"./arrow_right.svg": 99674,
	"./arrow_up.svg": 28259,
	"./arrow_up_green.svg": 83935,
	"./barcode_icon.svg": 66006,
	"./book-open.svg": 73998,
	"./bug.svg": 29740,
	"./bug_white.svg": 21590,
	"./calendar.svg": 81072,
	"./camera-capture.svg": 79342,
	"./checkbox_check.svg": 61124,
	"./checkmark-circle-2.svg": 12811,
	"./circle-check-solid.svg": 88583,
	"./ciuperca.svg": 62964,
	"./ciuperca_white.svg": 93326,
	"./close-red.svg": 64780,
	"./color-picker.svg": 47674,
	"./columns.svg": 29743,
	"./combustibil.svg": 78137,
	"./cultura.svg": 99816,
	"./culture.svg": 54004,
	"./current_position.svg": 18009,
	"./details_file.svg": 20645,
	"./dialog-close-gray.svg": 3423,
	"./dialog-close-white.svg": 65193,
	"./dialog-close.svg": 38357,
	"./download.svg": 59474,
	"./drawing_pointer.svg": 16670,
	"./droplet-off-outline.svg": 12201,
	"./droplet-simple-green.svg": 68965,
	"./droplet.svg": 17700,
	"./droplet_full.svg": 2600,
	"./droplet_white.svg": 62462,
	"./edit.svg": 23374,
	"./erbicid.svg": 41300,
	"./file.svg": 19880,
	"./floppy.svg": 29528,
	"./fungicid.svg": 35579,
	"./fungicid_disease.svg": 72340,
	"./fungicid_disease_white.svg": 6798,
	"./hectar.svg": 22379,
	"./home_icon.svg": 5413,
	"./ingrasamant_chimic.svg": 9783,
	"./left_arrow.svg": 40807,
	"./list.svg": 50710,
	"./loader-points.gif": 53636,
	"./machine_expanded.svg": 68299,
	"./map_draw_cancel.svg": 22770,
	"./map_draw_cancel_2.svg": 8281,
	"./map_draw_save_active.svg": 88028,
	"./map_draw_save_inactive.svg": 61549,
	"./map_draw_undo.svg": 24606,
	"./map_layers.svg": 66301,
	"./oameni.svg": 95639,
	"./options.svg": 10336,
	"./orange_check.svg": 15397,
	"./parcel.svg": 98341,
	"./parcel2.svg": 64429,
	"./parcel_merge.svg": 54900,
	"./parcel_split.svg": 85736,
	"./parcel_transfer.svg": 26953,
	"./payment_icon.svg": 48404,
	"./payment_icon_green.svg": 1616,
	"./photo-gallery-icon.svg": 56319,
	"./piese-de-schimb.svg": 30435,
	"./pin.svg": 98655,
	"./pin_inactive.svg": 54433,
	"./plus.svg": 68718,
	"./plus_green.svg": 61578,
	"./pricetags.svg": 87937,
	"./products_icon.svg": 37730,
	"./products_icon_gray.svg": 80400,
	"./receptie.svg": 7891,
	"./refresh_map.svg": 80472,
	"./refresh_map_green.svg": 95996,
	"./report_icon.svg": 70004,
	"./report_icon_green.svg": 26064,
	"./right_arrow.svg": 10118,
	"./right_arrow_black.svg": 26962,
	"./right_arrow_dg.svg": 89246,
	"./samanta.svg": 23111,
	"./samanta_2.svg": 32748,
	"./scale-gray.svg": 94360,
	"./scouting-gray.svg": 20412,
	"./scouting-green.svg": 44770,
	"./search.svg": 30490,
	"./simple-droplet.svg": 98217,
	"./straturi.svg": 37810,
	"./straturi_white.svg": 3524,
	"./sync-icon.svg": 37947,
	"./tractor.svg": 42823,
	"./tractor_light.svg": 65462,
	"./transfer.svg": 20703,
	"./trash-can-regular.svg": 29710,
	"./triangle-exclamation-solid.svg": 65884,
	"./utilaj.svg": 58123,
	"./warehouse_icon.svg": 17809,
	"./warning_yellow.svg": 64545,
	"./work_plus.svg": 37156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16400;